export default __webpack_public_path__ + "static/media/content.78769176.png";